import React, { useEffect, useState, useRef } from "react"
import { Link, useParams, useNavigate, useSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import DatePicker from "react-datepicker"
import { format } from 'date-fns'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import { GET, PUT, httpOk } from 'helpers/api'
import { DayOfTheWeek } from "../../../helpers/DayOfTheWeek";
import TransferAccess from './TransferAccess'
import MenuSchedule from './MenuSchedule'
import ReservationSettings from './ReservationSettings'
import TelegramGroupConnect from 'pages/parts/TelegramGroupConnect'
import HintIcon from 'pages/parts/HintIcon'
import PageTabs from 'pages/parts/PageTabs'
import AddressSuggestField from 'pages/parts/AddressSuggestField'
import { yandexReverseGeocode } from 'helpers/yandexGeocoder'
import { timezoneOptions } from 'helpers/timezones'

const MAP_KEY = 'b5de12cc-6217-4b13-9078-2e99c84df330'

// Начало операционного дня: ровный час с 00:00 до 12:00 (как «Открытие смены» у Clopos)
const DAY_START_OPTIONS = Array.from({ length: 13 }, (_, hour) => {
	const value = `${String(hour).padStart(2, '0')}:00`
	return { id: value, name: value }
})

// Часовой пояс точки (IANA) — список из браузера, считается один раз
const TIMEZONE_OPTIONS = timezoneOptions()

function CreateUpdate() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const mapRef = useRef(null);
	const pointRef = useRef();
	// save() вкладки «Бронь столов» — её поля сохраняются общей кнопкой
	const reservationSaveRef = useRef(null);

	const [data, setData] = useState({
		"name": '',
		"address": '',
		"phone": '',
		"longitude": 41.311081,
		"latitude": 69.240562,
		"settings": {},
		"plans": [],
		"year": "",
		"is_vat_payer": "",
	})
	const [modalYmap, setModalYmap] = useState(false)
	// ?tab=plan — сразу на вкладку (ссылка из сетевого отчёта «План и факт»)
	const [searchParams] = useSearchParams()
	const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'general')
	// Меню точки: 0 — меню канала (своего правила нет), -1 — основное меню точки,
	// остальное — id внешнего меню бренда
	const [menuOptions, setMenuOptions] = useState([])
	const [posMenuId, setPosMenuId] = useState(0)
	const [posWorkingDays, setPosWorkingDays] = useState([
		{ day: 1, activated: true, working_start_time: "09:00", working_end_time: "23:59", start_time: new Date(new Date().setHours(9, 0, 0, 0)), end_time: new Date(new Date().setHours(23, 59, 0, 0)) },
		{ day: 2, activated: true, working_start_time: "09:00", working_end_time: "23:59", start_time: new Date(new Date().setHours(9, 0, 0, 0)), end_time: new Date(new Date().setHours(23, 59, 0, 0)) },
		{ day: 3, activated: true, working_start_time: "09:00", working_end_time: "23:59", start_time: new Date(new Date().setHours(9, 0, 0, 0)), end_time: new Date(new Date().setHours(23, 59, 0, 0)) },
		{ day: 4, activated: true, working_start_time: "09:00", working_end_time: "23:59", start_time: new Date(new Date().setHours(9, 0, 0, 0)), end_time: new Date(new Date().setHours(23, 59, 0, 0)) },
		{ day: 5, activated: true, working_start_time: "09:00", working_end_time: "23:59", start_time: new Date(new Date().setHours(9, 0, 0, 0)), end_time: new Date(new Date().setHours(23, 59, 0, 0)) },
		{ day: 6, activated: true, working_start_time: "09:00", working_end_time: "23:59", start_time: new Date(new Date().setHours(9, 0, 0, 0)), end_time: new Date(new Date().setHours(23, 59, 0, 0)) },
		{ day: 7, activated: true, working_start_time: "09:00", working_end_time: "23:59", start_time: new Date(new Date().setHours(9, 0, 0, 0)), end_time: new Date(new Date().setHours(23, 59, 0, 0)) },
	])
	const [defaultState, setDefaultState] = useState({
		center: [41.311081, 69.240562],
		zoom: 11,
		controls: ["zoomControl"]
	});

	// Точка на карте выбрана (кликом или из поиска): координаты и адрес в форму,
	// а для найденного поиском — ещё и центр карты, чтобы метка была видна
	function pickMapAddress(picked, center = false) {
		setData((prev) => ({
			...prev,
			'latitude': picked.latitude,
			'longitude': picked.longitude,
			'map_address': picked.full_address,
		}))
		if (center && typeof mapRef.current?.setCenter === 'function') {
			mapRef.current.setCenter([picked.latitude, picked.longitude], 17)
		}
	}

	async function createUpdate() {
		if (reservationSaveRef.current && !(await reservationSaveRef.current())) {
			setActiveTab('reservations')
			return
		}

		var sendData = { ...data }
		sendData.working_days = posWorkingDays

		const response = await PUT('/pos', sendData, { loader: true })

		if (httpOk(response)) {
			await PUT('/menu-schedules/pos', {
				pos_id: data.id,
				external_menu_id: posMenuId > 0 ? posMenuId : null,
				use_main_menu: posMenuId === -1,
			}, { loader: true, notification: false })

			navigate('/pos')
		}
	}

	// Список внешних меню бренда и текущее меню точки — для селекта «Меню по умолчанию»
	async function getMenus() {
		const response = await GET('/external-groups', { size: 100 })
		if (!httpOk(response)) return

		// Пустое поле = «как в канале»: точка показывает меню, выбранное в конструкторе канала
		const menus = (response.data?.data ?? []).map((item) => ({ id: item.id, name: item.name }))
		setMenuOptions([
			{ id: -1, name: t('pos_default_menu_main') },
			...menus,
		])

		const schedules = await GET('/menu-schedules', { pos_id: id })
		if (httpOk(schedules)) {
			const row = (schedules.data?.data ?? []).find(item => !item.price_period_id)
			if (row) setPosMenuId(row.external_menu_id ? Number(row.external_menu_id) : -1)
		}
	}

	function handleSettingChange(e, type) {
		var dataCopy = { ...data }
		if (type === 'checkbox') {
			dataCopy.settings[e.target.name] = e.target.checked
		}
		if (type === 'text') {
			dataCopy.settings[e.target.name] = e.target.value
		}

		setData(dataCopy)
	}

	function renderWeekName(id) {
		for (let i = 0; i < DayOfTheWeek.length; i++) {
			if (DayOfTheWeek[i]['id'] === id) {
				return DayOfTheWeek[i]['name' + localStorage.getItem('i18nextLng').split('-').join('')]
			}
		}
	}

	function selectTime(time, index, type) {
		var posWorkingDaysCopy = [...posWorkingDays]
		if (type === 'start_time') {
			posWorkingDaysCopy[index]['start_time'] = time
			posWorkingDaysCopy[index]['working_start_time'] = format(new Date(time), 'HH:mm')
		} else {
			posWorkingDaysCopy[index]['end_time'] = time
			posWorkingDaysCopy[index]['working_end_time'] = format(new Date(time), 'HH:mm')
		}
		setPosWorkingDays(posWorkingDaysCopy)
	}

	// async function parseCoordinates(value) {
	// 	var numbers = value.replace(/\s/g, '').split(",")
	// 	var latitude = numbers[0];
	// 	var longitude = numbers[1];

	// 	setDefaultState({
	// 		center: [latitude, longitude],
	// 		zoom: 11,
	// 		controls: ["zoomControl"]
	// 	})
	// 	setData({
	// 		...data,
	// 		'coordinates': value,
	// 		'longitude': longitude,
	// 		'latitude': latitude
	// 	})
	// }

	function setDaysActivated(index) {
		var posWorkingDaysCopy = [...posWorkingDays]
		posWorkingDaysCopy[index]['activated'] = !posWorkingDaysCopy[index]['activated']
		setPosWorkingDays(posWorkingDaysCopy)
	}

	async function getData() {
		try {
			var response = await GET(`/pos/${id}`, {}, { loader: true })

			if (httpOk(response)) {
				response = response.data;

				var date = new Date();
				var posWorkingDaysCopy = [...posWorkingDays]
				for (let i = 0; i < response.working_days.length; i++) {
					var startFormatted = null
					var endFormatted = null

					if (response.working_days[i]['start_time']) {
						const start = response.working_days[i]['start_time'].split(':');
						const end = response.working_days[i]['end_time'].split(':');
						startFormatted = new Date(date.getFullYear(), date.getMonth(), date.getDate(), start[0], start[1], 0, 0);
						endFormatted = new Date(date.getFullYear(), date.getMonth(), date.getDate(), end[0], end[1], 0, 0);
					}

					posWorkingDaysCopy[i]['activated'] = response.working_days[i]['activated']
					posWorkingDaysCopy[i]['start_time'] = startFormatted
					posWorkingDaysCopy[i]['end_time'] = endFormatted
					posWorkingDaysCopy[i]['working_start_time'] = response.working_days[i]['start_time']
					posWorkingDaysCopy[i]['working_end_time'] = response.working_days[i]['end_time']
				}
				setPosWorkingDays(posWorkingDaysCopy)

				if (!response.longitude || !response.latitude) {
					response.longitude = 69.240562
					response.latitude = 41.311081
				} else {
					response.longitude = Number(response.longitude)
					response.latitude = Number(response.latitude)

					setDefaultState({
						center: [response.latitude, response.longitude],
						zoom: 11,
						controls: ["zoomControl"]
					})
				}
				setData(response)
			}
		} catch (error) {
			console.error(error);
		}
	}

	useEffect(() => {
		getData()
		getMenus()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex mb-2">
				<div className="d-flex">
					<h4 className="vertical-center">
						{t('pos')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('edit')}</h6>
					</div>
				</div>
			</div>

			{/* Форма узкая, чтобы поля не растягивались на весь экран; плану нужны все 12 месяцев */}
			<div className="card" style={{ maxWidth: activeTab === 'plan' ? undefined : 820 }}>
				<div className="card-body">
					<form autoComplete="off">
						<PageTabs
							active={activeTab}
							onChange={setActiveTab}
							tabs={[
								{ key: 'general', label: t('general') },
								{ key: 'menu', label: t('menu') },
								{ key: 'working_days', label: t('working_days') },
								{ key: 'cashbox', label: t('cashbox') },
								{ key: 'services', label: t('services') },
								// Бронь — у существующей точки: настройки сохраняются отдельно по её id
								id && { key: 'reservations', label: t('reservations_tab') },
								// Подключение группы — только у существующей точки: код выписывается на её бренд
								id && { key: 'telegram', label: 'Telegram' },
								{ key: 'plan', label: t('plan') },
							]} />

						<div className={activeTab !== 'general' ? 'd-none' : 'row'}>
							<div className="col-12">
								<div>
									<div className="d-flex gap-2">
										<div className="form-group w-100">
											<label>{t("coordinates")} Yandex<span className="required-mark">*</span></label>
											<div className="position-relative">
												<input type="text" className="form-control" name="name"
													autoFocus
													disabled
													value={`${data.latitude}, ${data.longitude}` ?? ''}
													onChange={(e) => { }} />
												<div className="input-button-right"
													onClick={() => setModalYmap(true)}>
													<i className="uil uil-map-marker input-icon"></i>
												</div>
											</div>
										</div>
										<div className="form-group w-100">
											<label>{t("address")}</label>
											<input type="text" className="form-control" name="map_address"
												disabled
												value={data.map_address ?? ''}
												onChange={() => { }} />
										</div>
									</div>

									<div className="d-flex gap-2">
										<div className="form-group w-100">
											<label>{t("name2")}<span className="required-mark">*</span></label>
											<input type="text" className="form-control" name="name" value={data.name ?? ''}
												onChange={(e) => setData({ ...data, 'name': e.target.value })} autoFocus />
										</div>
										<div className="form-group w-100">
											<label>{t("short_name")}</label>
											<input type="text" className="form-control" name="short_name" value={data.short_name ?? ''}
												onChange={(e) => setData({ ...data, 'short_name': e.target.value })} />
										</div>
										<div className="form-group w-100">
											<label>{t("tin")}</label>
											<input type="text" className="form-control" name="tin" value={data.tin ?? ''}
												onChange={(e) => setData({ ...data, 'tin': e.target.value })} />
										</div>
									</div>
									<div className="d-flex gap-2">
										<div className="form-group w-100">
											<label>{t('cheque_phone')}</label>
											<input type="number" className="form-control" name="phone"
												value={data.phone ?? ''}
												onChange={(e) => setData({ ...data, 'phone': e.target.value })} />
										</div>
										<div className="form-group w-100">
											<label>{t('pos_phone')}</label>
											<input type="number" className="form-control" name="phone_call_center"
												value={data.phone_call_center ?? ''}
												onChange={(e) => setData({ ...data, 'phone_call_center': e.target.value })} />
										</div>
									</div>
									<div className="d-flex gap-2">
										<div className="form-group w-100">
											<label>{t("address")}</label>
											<input type="text" className="form-control" name="address" value={data.address ?? ''}
												onChange={(e) => setData({ ...data, 'address': e.target.value })} />
										</div>
										<div className="form-group w-100">
											<label>{t('maximum_delivery_distance')} (km)</label>
											<input type="text" className="form-control" name="delivery_distance"
												value={data.delivery_distance ?? ''}
												onChange={(e) => setData({ ...data, 'delivery_distance': e.target.value.replace(/[^0-9.]/g, '') })} />
										</div>

									</div>

									<div className="d-flex gap-2">
										<div className="form-group w-50">
											<label>{t('day_start')}<HintIcon text={t('day_start_hint')} /></label>
											<Select
												options={DAY_START_OPTIONS}
												value={DAY_START_OPTIONS.find(option => option.id === (data.day_start ?? '00:00')) || DAY_START_OPTIONS[0]}
												onChange={(option) => setData({ ...data, 'day_start': option.id })}
												placeholder=""
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id} />
										</div>
										<div className="form-group w-50">
											<label>{t('timezone')}<HintIcon text={t('timezone_hint')} /></label>
											<Select
												options={TIMEZONE_OPTIONS}
												value={TIMEZONE_OPTIONS.find(option => option.id === (data.timezone ?? 'Asia/Tashkent')) || null}
												onChange={(option) => setData({ ...data, 'timezone': option.id })}
												placeholder=""
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id} />
										</div>
									</div>

									<div className="d-flex justify-content-between">
										<p className="fw-600 vertical-center">{t('is_vat_payer')}</p>
										<div className="form-check form-switch form-switch-md">
											<input type="checkbox" className="form-check-input" name="is_vat_payer"
												checked={data?.is_vat_payer}
												onChange={(e) => setData({ ...data, 'is_vat_payer': e.target.checked })} />
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className={activeTab !== 'reservations' ? 'd-none' : 'row'}>
							<div className="col-12">
								{/* Смонтирована всегда: правки не теряются при смене вкладки */}
								<ReservationSettings posId={data.id} saveRef={reservationSaveRef} />
							</div>
						</div>

						<div className={activeTab !== 'menu' ? 'd-none' : 'row'}>
							<div className="col-12">
								<div>
									<div className="form-group">
										<label>{t('pos_default_menu')}<HintIcon text={t('pos_default_menu_hint')} /></label>
										<Select
											isClearable
											options={menuOptions}
											value={menuOptions.find(option => option.id === posMenuId) || ''}
											onChange={(option) => setPosMenuId(option ? option.id : 0)}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id} />
									</div>

									<MenuSchedule posId={data.id} />
								</div>
							</div>
						</div>

						<div className={activeTab !== 'working_days' ? 'd-none' : 'row'}>
							<div className="col-12">
								<div className="form-group">
									<div className="table-responsive">
										<table className="table table-bordered mb-0 w-auto">
											<thead>
												<tr>
													<th>#</th>
													<th>{t('days_of_the_week')}</th>
													<th style={{ width: 130 }}>{t('opening_time')}</th>
													<th style={{ width: 130 }}>{t('closing_time')}</th>
												</tr>
											</thead>
											<tbody>
												{posWorkingDays.map((item, index) => (
													<tr key={index}>
														<td className="vertical-middle">
															<input type="checkbox" className="form-check-input"
																checked={item.activated}
																onChange={() => setDaysActivated(index)} />
														</td>
														<td className="vertical-middle">{renderWeekName(item.day)}</td>
														<td>
															{item.activated ?
																<DatePicker
																	className="form-control text-center"
																	selected={posWorkingDays[index]['start_time'] ? new Date(posWorkingDays[index]['start_time']) : ''}
																	onChange={(date) => selectTime(date, index, 'start_time')}
																	showTimeSelect
																	showTimeSelectOnly
																	timeIntervals={30}
																	timeCaption={t('time')}
																	timeFormat="HH:mm"
																	dateFormat="HH:mm" />
																:
																<span>-</span>
															}
														</td>
														<td>
															{item.activated ?
																<DatePicker
																	className="form-control text-center"
																	selected={posWorkingDays[index]['end_time'] ? new Date(posWorkingDays[index]['end_time']) : ''}
																	onChange={(date) => selectTime(date, index, 'end_time')}
																	showTimeSelect
																	showTimeSelectOnly
																	timeIntervals={30}
																	timeCaption={t('time')}
																	timeFormat="HH:mm"
																	dateFormat="HH:mm" />
																:
																<span>-</span>
															}
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>

						<div className={activeTab !== 'cashbox' ? 'd-none' : 'row'}>
							<div className="col-12" style={{ maxWidth: 480 }}>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('guests_selection')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="bool_people_select"
											disabled
											checked={data?.settings?.bool_people_select}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('button_monitor')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="bool_monitor_button"
											disabled
											checked={data?.settings?.bool_monitor_button}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('button_prepayment')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="bool_prepayment_button"
											disabled
											checked={data?.settings?.bool_prepayment_button}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('button_delivery')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="bool_delivery_button"
											disabled
											checked={data?.settings?.bool_delivery_button}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('button_remove_multiple_products')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="bool_remove_multiple_products"
											disabled
											checked={data?.settings?.bool_remove_multiple_products}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('show_sale_price')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="bool_show_sale_price"
											disabled
											checked={data?.settings?.bool_show_sale_price}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('change_delivery_price')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="delivery_price_changeable"
											disabled
											checked={data?.settings?.delivery_price_changeable}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('fast_food_mode')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="bool_fast_food_mode"
											disabled
											checked={data?.settings?.bool_fast_food_mode}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('change_hall_service_percentage')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="change_hall_service_percentage"
											disabled
											checked={data?.settings?.change_hall_service_percentage}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('waiters_takeaway_button')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="is_takeaway"
											disabled
											checked={data?.settings?.is_takeaway}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('split_products')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="is_split_products"
											disabled
											checked={data?.settings?.is_split_products}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('online_stop_list')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="online_stop_list"
											disabled
											checked={data?.settings?.online_stop_list}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('cheque_online')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="is_cheque_online"
											disabled
											checked={data?.settings?.is_cheque_online}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('image')}</p>
									<div className="form-check form-switch form-switch-sm">
										<input type="checkbox" className="form-check-input" name="is_show_image"
											disabled
											checked={data?.settings?.is_show_image}
											onChange={(e) => handleSettingChange(e, 'checkbox')} />
									</div>
								</div>
							</div>
						</div>

						{/* TransferAccess грузит данные при монтировании — рендерим только на своей вкладке */}
						{activeTab === 'services' &&
							<TransferAccess activeTab={2} id={data.id}></TransferAccess>
						}

						{id &&
							<div className={activeTab !== 'telegram' ? 'd-none' : 'row'}>
								<div className="col-12">
									<TelegramGroupConnect bare />
								</div>
							</div>
						}

						{/* План продаж и расходов задаётся на экране «Планы» сетевых отчётов: все филиалы, каналы,
						    агрегаторы и категории на одном экране (sales_plans). Старая таблица pos_plans убрана. */}
						{activeTab === 'plan' &&
							<div className="text-center py-5">
								<i className="uil uil-calendar-alt d-block mb-2" style={{ fontSize: '40px', color: 'var(--bs-primary)' }}></i>
								<h5 className="mb-2">{t('chain_plans_moved_title')}</h5>
								<p className="text-muted mb-3 mx-auto" style={{ maxWidth: '560px' }}>{t('chain_plans_moved_text')}</p>
								<Link to="/chain/plans" className="btn btn-primary" style={{ borderRadius: '10px', fontWeight: 600 }}>
									<i className="uil uil-arrow-right me-1"></i>
									{t('chain_plans_open')}
								</Link>
							</div>
						}

						<div className="btn-wrapper gap-2">
							<Link className="btn btn-warning btn-rounded btn-wide" to="/pos">
								{t('cancel')}
							</Link>
							<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="4"
								onClick={() => createUpdate()}>
								{t('save')}
							</button>
						</div>
					</form>
				</div>
			</div>

			{/* MODAL MAP */}
			<Modal show={modalYmap} animation={false} dialogClassName="custom-delivery-modal"
 onHide={() => setModalYmap(false)}>
				<Modal.Body>
					<div className="row">
						<div className="col-md-12 position-relative" style={{ height: '80vh' }}>
							{/* Поиск адреса поверх карты. SearchControl из JS API ищет через сервис, который
								не принимает ключи нового кабинета Яндекса, поэтому — своё поле на HTTP-геокодере */}
							<AddressSuggestField
								className="map-address-search"
								mapToken={MAP_KEY}
								placeholder={t('search_address')}
								onPick={(picked) => pickMapAddress(picked, true)} />
							<YMaps
								style={{ height: '80vh' }}
								query={{
									load: "package.full",
									apikey: MAP_KEY
								}}>
								<Map
									instanceRef={(mapInstance) => { mapRef.current = mapInstance; }}
									style={{ height: '80vh' }}
									defaultOptions={{
										copyrightUaVisible: false,
										yandexMapDisablePoiInteractivity: true,
									}}
									defaultState={defaultState}
									onClick={async (event) => {
										const coords = event.get("coords");
										const found = await yandexReverseGeocode(MAP_KEY, coords[0], coords[1]).catch(() => null);
										pickMapAddress({
											'latitude': coords[0],
											'longitude': coords[1],
											'full_address': found?.full_address || `${Number(coords[0]).toFixed(6)}, ${Number(coords[1]).toFixed(6)}`,
										});
									}}>
									<Placemark instanceRef={pointRef} geometry={[data.latitude, data.longitude]} />
								</Map>
							</YMaps>
						</div>
					</div>
					<div className="d-flex w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100 me-2" style={{ 'flex': 1 }}
							onClick={() => setModalYmap(false)}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100" style={{ 'flex': 3 }}
							onClick={() => setModalYmap(false)}>
							<span>{t('save')}</span>
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL MAP */}
		</>
	)
}

export default CreateUpdate